/**
 * Remove all product sections if user doesn't have the password
 */
const productPasswordElement = document.querySelector("#productPassword");

if (productPasswordElement) {
	const targetSection = productPasswordElement.closest("section");
	const mainContent = document.querySelector("#MainContent");

	if (mainContent) {
		const sections = mainContent.querySelectorAll("section");
		sections.forEach(section => {
			// Remove all sections except for the one containing the password form
			if (section !== targetSection) {
				section.remove();
			}
		});
	}
}